/**
 * @see https://www.npmjs.com/package/qs
 */
import qs from 'qs';

var default_day_range = 150;

export default {
    data() {
        return {
            
            search: {
                query: '',

                date_range: dayjs().subtract(default_day_range, 'days').format('YYYY-MM-DD') + ' to ' + dayjs().format('YYYY-MM-DD'),
                sd: dayjs().subtract(default_day_range, 'days').format('YYYY-MM-DD'),

                //start_date: '2017-10-30',
                ed: dayjs().format('YYYY-MM-DD'),

                fact_or_opinion: null,

                verdict: [],

                claim_sources: [],

                verification_sources: [],

                verification_type: [],

                fact_check_sources: [],

                verdict_basis_list: [],

                featured_fc_id: 0,

                all_time: 0,

                max_search_date: null,

                method: '',
            },

            data_sources: {
                default: 'https://www.realclearpolitics.com/fact_check_review/json/live/recent_query_live.jsonp',
                search_options: 'https://www.realclearpolitics.com/fact_check_review/json/live/nav_datav2_live.jsonp',
                search_api: window.location.protocol + '//util.realclearpolitics.com/fact_check/apiv2.php',
                posts_feed: 'https://www.realclearfoundation.org/fact_check_review/posts_feed.jsonp',
                featured_fact_checks: 'https://www.realclearpolitics.com/fact_check_review/feed/featured_fcs.jsonp',
            },

        };
    },
    computed: {

    },
    methods: {

        doSearch(){
            /**
             * To Do: create the loop of requests to get the required data
             */
        },

        getData(search, method){
            return new Promise((resolve, reject) => {

                search.method = method;

                if( process.env.NODE_ENV == 'development' ){
                    search.override = 1;
                }

                // search = qs.stringify(search);
                this.$emit('searching', true);

                console.log("STRINGIFIED SEARCH: ", search, process.env.NODE_ENV);

                this.$http({
                    method: 'get',
                    url: this.data_sources.search_api,
                    params: search,
                })
                .then((res) => {
                    this.$emit('searching', false);
                    resolve(res);
                })
                .catch(error => {
                    this.$emit('searching', false);
                    console.log("AJAX Error: ", error, "Method: ", method);
                    reject(error);
                });
            });
        },

        cache_buster: function() {
            return Date.now();
        },
    },
};